import { MUIDataTableState } from 'mui-datatables';

export interface PaginationApiModel {
  'list-limit': number;
  'list-offset': number;
  'sorting-direction'?: 'ascending' | 'descending';
  'sorting-name'?: string;
}

export interface PaginationViewModel {
  page: number;
  rowsPerPage: number;
  sortOrder?: {
    name: string;
    direction: 'asc' | 'desc';
  };
}

type PaginationChange = {
  pagination: PaginationViewModel;
};

export const defaultPaginationSettings = (): PaginationViewModel => ({
  rowsPerPage: 10,
  page: 0,
});

export const mapPaginationViewToApiModel = (viewPagination: PaginationViewModel): PaginationApiModel => {
  const apiPagination: PaginationApiModel = {
    'list-limit': viewPagination.rowsPerPage,
    'list-offset': viewPagination.page * viewPagination.rowsPerPage,
  };
  if (viewPagination.sortOrder) {
    apiPagination['sorting-name'] = viewPagination.sortOrder.name;
    if (viewPagination.sortOrder.direction === 'asc') {
      apiPagination['sorting-direction'] = 'ascending';
    } else if (viewPagination.sortOrder.direction === 'desc') {
      apiPagination['sorting-direction'] = 'descending';
    }
  }
  return apiPagination;
};

export const mapOnTableChangeEventToPaginationViewModelChange = (
  action: string,
  tableState: MUIDataTableState
): PaginationChange | null => {
  const pageResettingActions = [ 'changeRowsPerPage', 'sort' ];
  if (pageResettingActions.includes(action)) {
    return { pagination: createPaginationViewResetToInitialPage(tableState) };
  } else if (action === 'changePage') {
    return { pagination: createPaginationViewSetToPage(tableState, tableState.page) };
  } else {
    return null;
  }
};

const createPaginationViewResetToInitialPage = (tableState: MUIDataTableState): PaginationViewModel => createPaginationViewSetToPage(tableState, 0);

const createPaginationViewSetToPage = (tableState: MUIDataTableState, page: number): PaginationViewModel => ({
  rowsPerPage: tableState.rowsPerPage,
  sortOrder: tableState.sortOrder,
  page
});